
import { Factcheck, ScrapedArticle } from "@/types";
import { Component, Prop, VModel, Vue, Watch } from "vue-property-decorator";

import * as FactcheckServices from "@/services/FactCheckService";

@Component
export default class UseScrapedArticleDialog extends Vue {
  @VModel({ required: true }) show!: boolean;
  @Prop({ required: true }) article!: ScrapedArticle;

  addToFactcheck = false;
  searchQuery = "";
  searchLoading = false;

  factchecks = [] as Factcheck[];

  selectedFactcheck = null as Factcheck | null;

  @Watch("show")
  onShowChanged(val: boolean) {
    //    if clolsed, reset
    if (!val) {
      this.addToFactcheck = false;
      this.searchQuery = "";
      this.selectedFactcheck = null;
      this.factchecks = [];
    }
  }

  async searchFactchecks() {
    this.searchLoading = true;
    const data = await FactcheckServices.GetAllFactChecks({
      query: this.searchQuery.length > 0 ? this.searchQuery : "*",
      category: null,
      dateRange: null,
      numericRating: null,
      partners: [],
    });
    this.factchecks = data;
    this.searchLoading = false;
  }

  @Watch("addToFactcheck")
  @Watch("searchQuery")
  async onAddToFactcheckChanged() {
    if (this.addToFactcheck) {
      await this.searchFactchecks();
    }
  }
}
